import React from 'react'
import { SponsorLogoIcon } from '@/atoms/Icons/SponsorLogo'
import { TicketIcon } from '@/atoms/Icons/TicketIcon'
import { Popover } from '@/atoms/Popover'
import { CaptionMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { useTheatricalPromotionContext } from '@/views/TicketCheckoutViews/components/TheatricalPromotionContext'

export const PremierePartnerPill = () => {
  const { t } = useTranslate('tickets')
  const { experiments } = useTheatricalPromotionContext()

  const experimentValue = experiments?.['premier-venue-pill-badge']
  if (experimentValue !== 'label' && experimentValue !== 'badge') {
    return null
  }
  const isBadge = experimentValue === 'badge'
  if (isBadge) {
    return (
      <Popover
        className="!z-10"
        title={t('premierePartner', 'Premiere Partner')}
        description={
          <CaptionMD color="core-gray-400" className="mt-2">
            {t(
              'premierePartnerDescription',
              'This theater partners with Angel to host exclusive premieres and events.',
            )}
          </CaptionMD>
        }
        icon={<TicketIcon color="error-400" size={20} />}
        triggerComponent={
          <div>
            <SponsorLogoIcon />
          </div>
        }
      />
    )
  }

  return (
    <Popover
      className="!z-10"
      title={t('premierePartner', 'Premiere Partner')}
      description={
        <CaptionMD color="core-gray-400" className="mt-2">
          {t('premierePartnerDescription', 'This theater partners with Angel to host exclusive premieres and events.')}
        </CaptionMD>
      }
      icon={<TicketIcon color="error-400" size={20} />}
      triggerComponent={
        <div className="relative flex items-center justify-center gap-1 rounded-full border border-error-400 bg-error-100 px-3 py-0.5">
          <TicketIcon color="error-400" size={14} />
          <CaptionMD color="core-gray-800">{t('premierePartner', 'Premiere Partner')}</CaptionMD>
        </div>
      }
    />
  )
}
